import Dashboard from "../Pages/Dashboard/Dashboard";
import ConfinedSpaceCertificate from "../Pages/Form/Certificate/ConfinedSpaceCertificate";
import HotWork from "../Pages/Form/Certificate/HotWork";
import IsolationCertificate from "../Pages/Form/Certificate/IsolationCertificate";
import RadiationCertificate from "../Pages/Form/Certificate/RadiationCertificate";
import ActivePermitShift from "../Pages/Form/ActivePermitShift";
import FormsList from "../Pages/Form/FormsList";
import MainForm from "../Pages/Form/MainForm";
import PTWForm1 from "../Pages/Form/PTWForm1";
import PTWForm2 from "../Pages/Form/PTWForm2";
import Company from "../Pages/Master/Company/Company";
import Role from "../Pages/Master/Role/Role";
import Site from "../Pages/Master/Site/Site";
import Terminal from "../Pages/Master/Terminal/Terminal";
import User from "../Pages/Master/User/User";
import GetOeControllerList from "../Pages/Form/GetOeControllerList";
import GetEmail from "../Pages/Sigin/GetEmail";
import Login from "../Pages/Sigin/Login";
import ViewImage from "../Pages/Form/ViewImage";
import OTPComp from "../Pages/Sigin/OTP";
import GetPassword from "../Pages/Sigin/GetPassword";
import EmailTemplateList from "../Pages/EmailTemplate/EmailTemplateList";
import Report from "../Pages/Report/Report";

export const routerLink = [
  {
    path: `/formlist/${btoa("admin")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("contract staff")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("agt")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("technician")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("sme approver")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("engineer")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("operation manager")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("hsse verifier")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("permit issuer")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("lifting inspector")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("lead permit issuer")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("isolation owner")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("isolation verifier")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("oe")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: `/formlist/${btoa("controller")}`,
    component: FormsList,
    module:"formlist"
  },
  {
    path: "/dashboard",
    component: Dashboard,
    // module: "notauthenticate",
  },
  {
    path: "/activepermit",
    component: ActivePermitShift,
    // module: "notauthenticate",
  },
  {
    path: "/ptwform",
    component: MainForm,
     module: "formlist",
  },
  // {
  //   path: "/controllerroom",
  //   component: GetOeControllerList,
  // },
  // {
  //   path: "/ptwform2",
  //   component: PTWForm2,
  // },
  {
    path: "/terminal",
    component: Terminal,
  },
  {
    path: "/site",
    component: Site,
  },
  {
    path: "/user",
    component: User,
  },
  {
    path: `/report/${btoa("report")}`,
    component: Report,
  },
  // {
  //   path: "/role",
  //   component: Role,
  // },
  {
    path: "/company",
    component: Company,
  },
  {
    path: "/emailtemplate",
    component: EmailTemplateList,
    // module: "notauthenticate",
  },
];

export const linkRouter=[
  {
    path: "/getemail",
    component: GetEmail,
    // module: "notauthenticate",
  },
  {
    path: "/",
    component: Login,
    // module: "notauthenticate",
  },
  {
    path: "/image",
    component: ViewImage,
    // module: "notauthenticate",
  },
  {
    path: "/otp",
    component: OTPComp,
    // module: "notauthenticate",
  },
  {
    path: "/setpassword",
    component: GetPassword,
    // module: "notauthenticate",
  },
]




